module.exports = __webpack_public_path__ + "img/3.0f51e263.png";